import script from "./PrivacyCell.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyCell.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyCell.vue?vue&type=style&index=0&id=6edba303&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edba303"]])

export default __exports__